export default {
  namespaced: true,
  state: {
    gatewaySatus: 0
  },
  actions: {
    setGatewaySatus({ state }, gatewaySatus) {
      state.gatewaySatus = gatewaySatus
    }
  }
}
